/**
 * lib-blueprint
 *
 * Adapptio library for processing blueprints.
 *
 * @package lib-blueprint
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ISchemaConstIntegerOpts, SchemaConstInteger, ISchemaConstInteger } from "../const/SchemaConstInteger";
import { ISchemaValue, ISchemaValueOpts, SchemaValue } from "./SchemaValue";

export interface ISchemaValueIntegerOpts extends ISchemaValueOpts<ISchemaConstInteger>, ISchemaConstIntegerOpts {}

/**
 * Schema: Integer value
 *
 * @param opts Schema options
 */
export function SchemaValueInteger(opts: ISchemaValueIntegerOpts): ISchemaValue<ISchemaConstInteger> {

	return SchemaValue(SchemaConstInteger(opts), opts);

}
